<div class="review-terms" data-testid="review-terms">
  <puro-checkbox
    class="review-terms__checkbox"
    [checked]="isAccepted()"
    [label]="'createShipment.reviewAndPay.terms.checkboxAria' | translate"
    (checkedChange)="onCheckedChange($event)"
  />
  <div class="review-terms__copy" id="review-terms-copy">
    <puro-typography component="p" variant="body2">
      {{ 'createShipment.reviewAndPay.terms.agreeBefore' | translate }}
      <a
        class="review-terms__link"
        href="#"
        data-testid="review-terms-link"
        (click)="onTermsLinkClick($event)"
      >
        {{ 'createShipment.reviewAndPay.terms.terms' | translate }}
      </a>
      {{ 'createShipment.reviewAndPay.terms.agreeMiddle' | translate }}
      <a
        class="review-terms__link"
        [href]="consentPdfUrl()"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="review-consent-link"
      >
        {{ 'createShipment.reviewAndPay.terms.consent' | translate }}
      </a>
      {{ 'createShipment.reviewAndPay.terms.agreeAfter' | translate }}
    </puro-typography>
    <puro-typography component="p" variant="body2">
      {{ 'createShipment.reviewAndPay.terms.quote' | translate }}
    </puro-typography>
    <puro-typography component="p" variant="body2">
      {{ 'createShipment.reviewAndPay.terms.verification' | translate }}
    </puro-typography>
    @if (agreementError()) {
      <p class="review-terms__error" data-testid="review-terms-agreement-error" role="alert">
        {{ 'createShipment.reviewAndPay.terms.agreementRequired' | translate }}
      </p>
    }
  </div>
</div>
